export const allowedColorModuleProducts = ['OLIMP', 'PENTO', 'INTEGO', 'RONDO', 'Q.INTEGO', 'QUADRO.E', 'PURO.2.XR'];

export const allowedColorModuleProductGroups = [
    // 'Rolete'
];

export const allowedColorModuleProductSubGroups = [
    // String.raw`Rolete\Predokenske`
];
